import script from "./AddDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDevice.vue?vue&type=script&setup=true&lang=js"

import "./AddDevice.vue?vue&type=style&index=0&id=50b7039e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b7039e"]])

export default __exports__